import {
  AWCTableCell,
  TableCellAlign,
  TableCellTypes,
} from '@ansys-internal/awc-angular/tables';
import { TableColumn } from '@ansys-internal/awf-angular/contributions';
import { AWFTableColumn } from '@ansys-internal/awf-angular/core';
import { ContributionsEnum } from '../../contributions.enum';

@AWFTableColumn({
  id: ContributionsEnum.STUDY_TABLE_PROJECT_COLUMN,
  priority: 200,
})
export class StudyProjectColumn implements TableColumn {
  public id: string = ContributionsEnum.STUDY_TABLE_PROJECT_COLUMN;
  public priority: number = 200;
  public header: string = 'Project';
  public type: TableCellTypes = TableCellTypes.TEXT;
  public align: TableCellAlign = TableCellAlign.CENTER;

  public render(data: any): Promise<AWCTableCell> {
    return Promise.resolve({
      value: data.name,
    });
  }
}
